var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.784 10.759h1.172v1.172h-1.172v-1.172zM10.086 10.759h1.172v1.172h-1.172v-1.172zM7.389 10.759H8.56v1.172H7.389v-1.172z",
    fill: "#182341"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.62A4.626 4.626 0 0015.38 0a4.626 4.626 0 00-4.198 2.69H4.075L3.805 0H0v1.172h2.745l.169 1.682 1.07 10.703a1.934 1.934 0 00-1.294 1.822c0 1.065.866 1.931 1.93 1.931h.907A1.933 1.933 0 007.302 20a1.933 1.933 0 001.775-2.69h3.19A1.933 1.933 0 0014.043 20a1.933 1.933 0 001.776-2.69h1.437v-1.172H4.62a.76.76 0 010-1.518h12.634l.61-6.106A4.62 4.62 0 0020 4.62zM7.302 18.829a.76.76 0 11.002-1.52.76.76 0 01-.002 1.52zm6.74 0a.76.76 0 11.002-1.52.76.76 0 01-.001 1.52zM15.38 1.172a3.453 3.453 0 013.448 3.449 3.453 3.453 0 01-3.448 3.448 3.453 3.453 0 01-3.45-3.448 3.453 3.453 0 013.45-3.45zm.814 12.277H5.151l-.959-9.587h6.63a4.626 4.626 0 005.81 5.207l-.438 4.38z",
    fill: "#182341"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.622 3.927l-.829-.83L14.991 4.9l-1.026-1.025-.828.828 1.854 1.855 2.631-2.631z",
    fill: "#182341"
  })));
}

export default SvgLedOrder;